import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

export default function NotFound() {
  const { lang, t } = useLang();
  const base = `/${lang}`;

  return (
    <>
      <Seo title={`${t.notFound.title} | Tonouh Marketing`} description={t.notFound.body} />
      <section className="flex min-h-[60vh] items-center justify-center bg-paper-warm px-5 py-24">
        <div className="text-center">
          <p className="font-display text-7xl italic text-teal-600/30">404</p>
          <h1 className="mt-4 font-display text-3xl text-navy-900 sm:text-4xl" data-testid="notfound-title">
            {t.notFound.title}
          </h1>
          <p className="mt-3 text-navy-900/70">{t.notFound.body}</p>
          <Link to={`${base}`} data-testid="notfound-cta" className="btn-primary mt-8">
            {t.notFound.cta}
          </Link>
        </div>
      </section>
    </>
  );
}
